// extracted by mini-css-extract-plugin
module.exports = {"mailingListTitle":"MailingList_mailingListTitle_1nmVL","createListButton":"MailingList_createListButton_3EEEo"};